var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  rx: 4,
  fill: "#788AC4"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 9.25L7.25 12L13.5 5.75",
  stroke: "#FFFFFF",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconCheckboxChecked;